export enum SnackState {
  SUCCESS,
  ERROR,
  INFO,
  INITIAL,
}
